import { render, staticRenderFns } from "./divideClassMng.vue?vue&type=template&id=838cb58c"
import script from "./divideClassMng.vue?vue&type=script&lang=js"
export * from "./divideClassMng.vue?vue&type=script&lang=js"
import style0 from "./divideClassMng.vue?vue&type=style&index=0&id=838cb58c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports